import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/vBlixHome.png'
import _imports_1 from '../../assets/img/vBlixHomeDark.png'


const _withScopeId = n => (_pushScopeId("data-v-6d223f97"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "login-formulario"
}
const _hoisted_2 = { class: "dv-img col-12" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1
}
const _hoisted_5 = { class: "dv-row col-12" }
const _hoisted_6 = ["placeholder", "readonly"]
const _hoisted_7 = { class: "lbl-mixed" }
const _hoisted_8 = { class: "lbl-error" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "dv-row col-12" }
const _hoisted_11 = ["placeholder", "readonly"]
const _hoisted_12 = { class: "lbl-error" }
const _hoisted_13 = {
  key: 1,
  class: "dv-row col-12 text-center mt-5"
}
const _hoisted_14 = {
  key: 2,
  class: "dv-row col-12 text-center mt-5",
  style: {"color":"var(--color-primary)"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-spin pi-spinner",
  style: {"font-size":"110%","margin-right":"7px"}
}, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "w-100 registro-tool"
}


import { eStatusCode } from "@/model/GloblasEnum";
import { useForm } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/yup';
import * as yup from 'yup';
import { isEmail,traduceTexto } from '@/services/ui/GlobalFunctions';
import { PropType,computed } from 'vue';
import { IonButton } from '@ionic/vue';
import {useMainStore} from '@/store/main-store';

interface IServerResponse {
  tipo: number,
  msg: string  
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  props: {
 tipo: Number,
 serverResponse: Object as PropType<IServerResponse>,
 loading:Boolean,
 showRegistro:Boolean
},
  emits: ['onLogin','onRegistro'],
  setup(__props, { emit: __emit }) {

const props = __props;
const isPhone = computed(():boolean=>
{
    const data = new String(userId.value.value);
    const regExp = new RegExp('^[0-9]+$');
    const res =  regExp.test(data.toString());        
    return res;
});
const isDarkTheme = computed(():boolean=>
{    
    return useMainStore().isDarkTheme();
});
const phoneLenght = computed(():number=>
{
    const data = new String(userId.value.value);    
    return data.toString().length;
});
const emitOnLogin = __emit;
const { errors,handleSubmit, defineInputBinds } = useForm(
{
    validationSchema: toTypedSchema(
    yup.object(
    {
        userId: yup.string().required(traduceTexto('globals.requerido')).test(
        {                
          test(value, ctx) {return isUserIdValid(value,ctx);}
        }),
        clave: yup.string().required(traduceTexto('globals.requerido')),
    })),
});
const userId = defineInputBinds('userId');
const clave = defineInputBinds('clave');
const mailt = traduceTexto('globals.noEmail');
const isUserIdValid = (value:string,ctx: any) =>
{
    if (!isEmail(value) && value.length != 10) 
    {
        return ctx.createError({ message:  mailt})
    }
    if (value.length === 10) 
    {
        return true;                        
    }
    return true;
}
const onLogin = handleSubmit(async (values) => 
{          
   emitOnLogin('onLogin',values);   
});
const goRegistro = ()=>
{    
  emitOnLogin('onRegistro','registro');         
}

return (_ctx: any,_cache: any) => {
  return (__props.tipo === 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("form", {
          class: "w-100",
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onLogin) && _unref(onLogin)(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            (!isDarkTheme.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : (_openBlock(), _createElementBlock("img", _hoisted_4))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("input", _mergeProps({
              type: "text",
              class: ["form-control vb-control", {'control-error':_unref(errors).userId}]
            }, _unref(userId), {
              placeholder: _ctx.$t('login.UserId'),
              readonly: props.loading
            }), null, 16, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(errors).userId), 1),
              _createElementVNode("div", null, [
                (isPhone.value && !__props.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(phoneLenght.value) + " / 10", 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("input", _mergeProps({
              type: "password",
              class: "form-control vb-control"
            }, _unref(clave), {
              placeholder: _ctx.$t('login.Clave'),
              readonly: props.loading
            }), null, 16, _hoisted_11),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(errors).clave), 1)
          ]),
          (__props.serverResponse && __props.serverResponse.msg)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["dv-row col-12 mt-3 mb-3 dv-notificacion", {'dv-notificacion-ok':__props.serverResponse.tipo === _unref(eStatusCode).Ok ,
                            'dv-notificacion-error':__props.serverResponse.tipo !== _unref(eStatusCode).Ok}])
              }, _toDisplayString(__props.serverResponse.msg), 3))
            : _createCommentVNode("", true),
          (!props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_unref(IonButton), {
                  type: "submit",
                  fill: "outline",
                  color: 'control'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('login.Login')), 1)
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("b", null, _toDisplayString(_ctx.$t('globals.espere')), 1)
              ]))
        ], 32),
        (!props.loading && __props.showRegistro)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_unref(IonButton), {
                type: "button",
                fill: "clear",
                color: 'control',
                onClick: goRegistro
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('registro.registro')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})